export default __webpack_public_path__ + "static/media/contact.5d0e6794.png";